import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'chat:showReasoningByDefault';

const read = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

/**
 * User preference for whether assistant Steps (reasoning + tool activity)
 * are expanded by default in chat bubbles. Defaults to off so the chat
 * surface stays clean; users can opt in.
 */
export const useShowReasoningPref = (): [boolean, (next: boolean) => void] => {
  const [value, setValue] = useState<boolean>(read);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setValue(e.newValue === 'true');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const update = useCallback((next: boolean) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false');
    } catch {
      /* ignore */
    }
    setValue(next);
  }, []);

  return [value, update];
};
